module.exports = __webpack_public_path__ + "f1e38390c4bcc7525f4a9b9d48c1a8b6.png";